import Button from '@/components/buttons/Button'
import Download from '../component/Download'
import _get from 'lodash/get'
import { documentCenterStore } from '@/services/DocumentCenter/store'
import { parseDate } from '@/utilities/Date/parse'
import { notifyMessage, notifyProblem, notifyWarning } from '@/services/notify'

export const methods = {
  determineRows: async function(list) {
    if (!Array.isArray(list)) {
      return
    }

    var rows = list.map(entry => {
      const category = _get(entry, 'governingDocumentCategory.name', '')
      const documentName = _get(entry, 'description', '')
      const createdDate = parseDate(_get(entry, ['createdDate'], ''), 'LL')
      const governingDocumentID = _get(entry, ['governingDocumentID'], 0)

      return {
        category: category,
        documentName: documentName,
        uploaded: createdDate,
        edit: {
          component: Button,
          props: {
            onClick: () => {
              this.redirectToEdit(entry)
            },
            text: 'Edit'
          }
        },
        delete: {
          component: Button,
          props: {
            onClick: async () => {
              await this.confirmDeleteDocument(governingDocumentID, documentName)
            },
            text: 'Delete'
          }
        },
        document: {
          component: Download,
          props: {
            governingDocumentID: _get(entry, ['governingDocumentID'], 0),
            downloadPdf: governingDocumentID => {
              this.downloadPdf(governingDocumentID, _get(entry, ['documentURL'], ''))
            }
          }
        }
      }
    })

    this.rows = rows
  },

  createGoverningDocumentModal() {
    this.toggle = true
    this.selectedGoverningDocument = null
  },

  redirectToEdit(governingDocument) {
    this.toggle = true
    this.selectedGoverningDocument = governingDocument
  },

  async confirmDeleteDocument(governingDocumentID, documentName) {
    this.$buefy.dialog.confirm({
      title: 'Deleting Document',
      message: `Are you sure you want to <b>delete</b> this document: "${documentName}"?`,
      confirmText: 'Delete Document',
      type: 'is-danger',
      hasIcon: true,
      onConfirm: () => this.deleteGoverningDocument(governingDocumentID)
    })
  },

  async deleteGoverningDocument(governingDocumentID) {
    if (governingDocumentID) {
      await documentCenterStore.dispatch('deleteGoverningDocument', {
        governingDocumentID: governingDocumentID,
        done: () => {
          this.loading = false
          this.reload()
        }
      })
    }
  },

  async downloadPdf(governingDocumentID, documentURL) {
    if (this.isDebug == true) console.debug('downloadPdf...')

    if (!governingDocumentID || governingDocumentID == undefined || !documentURL) {
      notifyProblem('There is a problem downloading this document.')
    }

    try {
      var link = document.createElement('a')
      link.download = 'download.pdf'
      link.setAttribute('download', 'download.pdf')
      link.href = documentURL
      window.open(link, '_blank')

      notifyMessage(`Successfully downloaded the published document.`)
      return
    } catch (e) {
      if (this.isDebug == true) console.debug(e)
      notifyWarning('There was a problem downloading the statements of account.')
    }
  },

  async loadDocuentCenter() {
    if (this.isDebug == true) console.debug('in loadDocuentCenter()...')

    await documentCenterStore
      .dispatch('getDocumentCenterList', {
        hoaID: this.hoaId
      })
      .then(async ({ list }) => {
        await this.determineRows(list)
      })
  },

  async reload() {
    this.loading = true

    this.rows = []
    await this.loadDocuentCenter()

    this.loading = false
  }
}
